import { createStandaloneToast } from "@chakra-ui/react";
import {
  isRejectedWithValue,
  Middleware,
  MiddlewareAPI,
} from "@reduxjs/toolkit";

import theme from "definitions/chakra/theme";
import { showToast } from "pages/data-warehouse/components/Toast";

const toast = createStandaloneToast({ theme });
const silentEndpoints = new Set([
  "getMe",
  "getWarehouseImportStatus",
  "importWarehouseData",
  "importWarehouseDatabaseSource",
  "importWarehouseCloudSource",
  "importWarehouseApiConnector",
]);

/**
 * Log a warning and show a toast!
 */
export const rtkQueryErrorLogger: Middleware =
  (_api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      if (!silentEndpoints.has(action.meta.arg.endpointName)) {
        showToast(toast, {
          description: action.payload.data.message,
          status: "error",
          title: "Error",
        });
      }
    }

    return next(action);
  };
